import { Link } from 'react-router-dom';
import Text from '../text/Text';
import Button from '../button/Button';
import './styles.css'

export const FormationCard = ({ formation }) => {
    const { id, image, modality, date, title, description } = formation;

    return (
        <div className='formation'>
            <img src={image} alt={title} className='formation-image' />
            <div className='formation-texts'>
                <div className='formation-infos'>
                    <Text as='p' className='formation-modality'>{modality}</Text>
                    <Text as='p'>{date}</Text>
                </div>
                <div>
                    <Text as='p' fontSize={24} isBold={true}>{title}</Text>
                    {description && <Text as='p'>{description}</Text>}
                </div>
                <Link to={`/formacao/${id}`}>
                    <Button variant='normal'>
                        Ler Mais
                    </Button>
                </Link>
            </div>
        </div>
    );
    
};